import { client } from './client';

export const retrieveQuote = ({ quoteId, postcode, email }) =>
  client(`quote-by-email/${quoteId}`, {
    method: 'GET',
    params: {
      postcode: postcode,
      emailAddress: email
    }
  });
